const createFeatureFlagConfig = <T extends Record<string, readonly string[]>>(
  config: T,
) => config;

const createFeatureFlagValues = <T extends FeatureFlagsType>(
  values: T,
) => values;

const FEATURE_FLAG_CONFIG = createFeatureFlagConfig({
  tb_soft_auto_confirmation: ['on', 'off'],
  tc_homepage_v2: ['on', 'off'],
  tc_kameleoon_upgrade: ['on', 'off'],
  tc_offer_select: ['off', 'lower_placement_with_new_copy', 'upper_placement_with_new_copy', 'lower_placement_with_old_copy', 'upper_placement_with_old_copy'],
  tc_vrm_multivariant: ['off', 'green_border', 'larger_vrm_font', 'smaller_vrm_font'],
} as const);

type FeatureFlagConfig = typeof FEATURE_FLAG_CONFIG;

export type FeatureFlagName = keyof typeof FEATURE_FLAG_CONFIG;

type FeatureFlagNameIdentity = { [K in FeatureFlagName]: K }

export const FEATURE_FLAG_NAME = Object.fromEntries(
  Object.keys(FEATURE_FLAG_CONFIG).map((flagName) => [flagName, flagName]),
) as FeatureFlagNameIdentity;

export type FeatureFlagNameMap = typeof FEATURE_FLAG_NAME;

export type FeatureFlagsType = {
  [K in keyof FeatureFlagConfig]: FeatureFlagConfig[K][number];
};

export const DEFAULT_FEATURE_FLAGS = createFeatureFlagValues({
  [FEATURE_FLAG_NAME.tc_offer_select]: 'off',
  [FEATURE_FLAG_NAME.tc_vrm_multivariant]: 'off',
  [FEATURE_FLAG_NAME.tb_soft_auto_confirmation]: 'off',
  [FEATURE_FLAG_NAME.tc_kameleoon_upgrade]: 'off',
  [FEATURE_FLAG_NAME.tc_homepage_v2]: 'off',
} as const);

export const SERVER_SIDE_FLAG_NAMES:readonly FeatureFlagName[] = [
  FEATURE_FLAG_NAME.tc_vrm_multivariant,
  FEATURE_FLAG_NAME.tc_homepage_v2,
];
